/* tslint:disable */

declare var Object: any;
export interface TeomcompanyInterface {
  "companyId": number;
  "companyCode": string;
  "companyName": string;
  "nickName": string;
  "companyLevel": number;
  "parentId": number;
  "status": number;
  "isbase": number;
  "companyType"?: string;
  "companyLogo"?: string;
  "companyAddress"?: string;
  "companyAddress2"?: string;
  "companyPhone"?: string;
  "companyFax"?: string;
  "companyEmail"?: string;
  "companyCountry"?: string;
  "companyState"?: string;
  "companyZipcode"?: string;
  "taxfilenumber"?: string;
  "taxlocationCode"?: string;
  "taxcountry"?: string;
  "currencyCode"?: string;
  "cityId"?: number;
  "stateId"?: number;
  "countryId"?: number;
  "visionEn"?: string;
  "visionId"?: string;
  "visionMy"?: string;
  "visionTh"?: string;
  "missionEn"?: string;
  "missionId"?: string;
  "missionMy"?: string;
  "missionTh"?: string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "taxoffice"?: string;
  "gmtId"?: number;
  "localName"?: string;
  "uen"?: string;
  rel_emcompany?: any[];
  gemcity?: any;
}

export class Teomcompany implements TeomcompanyInterface {
  "companyId": number;
  "companyCode": string;
  "companyName": string;
  "nickName": string;
  "companyLevel": number;
  "parentId": number;
  "status": number;
  "isbase": number;
  "companyType": string;
  "companyLogo": string;
  "companyAddress": string;
  "companyAddress2": string;
  "companyPhone": string;
  "companyFax": string;
  "companyEmail": string;
  "companyCountry": string;
  "companyState": string;
  "companyZipcode": string;
  "taxfilenumber": string;
  "taxlocationCode": string;
  "taxcountry": string;
  "currencyCode": string;
  "cityId": number;
  "stateId": number;
  "countryId": number;
  "visionEn": string;
  "visionId": string;
  "visionMy": string;
  "visionTh": string;
  "missionEn": string;
  "missionId": string;
  "missionMy": string;
  "missionTh": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "taxoffice": string;
  "gmtId": number;
  "localName": string;
  "uen": string;
  rel_emcompany: any[];
  gemcity: any;
  constructor(data?: TeomcompanyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teomcompany`.
   */
  public static getModelName() {
    return "Teomcompany";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teomcompany for dynamic purposes.
  **/
  public static factory(data: TeomcompanyInterface): Teomcompany{
    return new Teomcompany(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teomcompany',
      plural: 'Teomcompanies',
      path: 'Teomcompanies',
      properties: {
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "companyName": {
          name: 'companyName',
          type: 'string'
        },
        "nickName": {
          name: 'nickName',
          type: 'string'
        },
        "companyLevel": {
          name: 'companyLevel',
          type: 'number'
        },
        "parentId": {
          name: 'parentId',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "isbase": {
          name: 'isbase',
          type: 'number'
        },
        "companyType": {
          name: 'companyType',
          type: 'string'
        },
        "companyLogo": {
          name: 'companyLogo',
          type: 'string'
        },
        "companyAddress": {
          name: 'companyAddress',
          type: 'string'
        },
        "companyAddress2": {
          name: 'companyAddress2',
          type: 'string'
        },
        "companyPhone": {
          name: 'companyPhone',
          type: 'string'
        },
        "companyFax": {
          name: 'companyFax',
          type: 'string'
        },
        "companyEmail": {
          name: 'companyEmail',
          type: 'string'
        },
        "companyCountry": {
          name: 'companyCountry',
          type: 'string'
        },
        "companyState": {
          name: 'companyState',
          type: 'string'
        },
        "companyZipcode": {
          name: 'companyZipcode',
          type: 'string'
        },
        "taxfilenumber": {
          name: 'taxfilenumber',
          type: 'string'
        },
        "taxlocationCode": {
          name: 'taxlocationCode',
          type: 'string'
        },
        "taxcountry": {
          name: 'taxcountry',
          type: 'string'
        },
        "currencyCode": {
          name: 'currencyCode',
          type: 'string'
        },
        "cityId": {
          name: 'cityId',
          type: 'number'
        },
        "stateId": {
          name: 'stateId',
          type: 'number'
        },
        "countryId": {
          name: 'countryId',
          type: 'number'
        },
        "visionEn": {
          name: 'visionEn',
          type: 'string'
        },
        "visionId": {
          name: 'visionId',
          type: 'string'
        },
        "visionMy": {
          name: 'visionMy',
          type: 'string'
        },
        "visionTh": {
          name: 'visionTh',
          type: 'string'
        },
        "missionEn": {
          name: 'missionEn',
          type: 'string'
        },
        "missionId": {
          name: 'missionId',
          type: 'string'
        },
        "missionMy": {
          name: 'missionMy',
          type: 'string'
        },
        "missionTh": {
          name: 'missionTh',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "taxoffice": {
          name: 'taxoffice',
          type: 'string'
        },
        "gmtId": {
          name: 'gmtId',
          type: 'number'
        },
        "localName": {
          name: 'localName',
          type: 'string'
        },
        "uen": {
          name: 'uen',
          type: 'string'
        },
      },
      relations: {
        rel_emcompany: {
          name: 'rel_emcompany',
          type: 'any[]',
          model: ''
        },
        gemcity: {
          name: 'gemcity',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teomcompany.ts